import { forwardRef } from 'react';
import { cn } from '@/utils/styles';
import { Slot } from '@radix-ui/react-slot';

export interface BottomNavItemProps extends React.ComponentProps<'button'> {
  asChild?: boolean;
  isActive?: boolean;
}

export const BottomNavItem = forwardRef<HTMLButtonElement, BottomNavItemProps>(
  ({ isActive, asChild, className, ...rest }, ref) => {
    const Comp = asChild ? Slot : 'button';

    return (
      <Comp
        ref={ref}
        data-active={isActive}
        className={cn(
          'flex flex-col items-center justify-center p-1 text-tertiary hover:text-primary active:text-primary transition-colors',
          'data-[active=true]:text-primary',
          '[&_span]:typography-footnote',
          className,
        )}
        {...rest}
      />
    );
  },
);

export type BottomNavBarProps = React.ComponentProps<'nav'>;

export const BottomNavBar = ({
  children,
  className,
  ...rest
}: BottomNavBarProps) => (
  <nav
    className={cn(
      'w-full flex justify-center items-center border-t border-stroke-secondary-subtle h-16 bg-background-blur-subtle shadow-glass-nav-inner backdrop-blur-md bg-clip-padding z-[12]',
      className,
    )}
    {...rest}
  >
    <div className="w-full max-w-lg px-4">
      {children}
    </div>
  </nav>
);
